Vue.component('webcallback-hours', {
	props: ['options', 'labellang'],
	template:	'<transition v-if="isActive" name="bounce" enter-active-class="bounceInUp" leave-active-class="bounceOutRight" v-bind:css="options.internal.isAnimationCompatibility">' +
			       '<div id="webcallback-hours" class="col-md-12">' +
							'<div class="row col-md-12">'+
								'<h3> {{ text.title }} </h3>' +
		 			    	//'<p v-if="hasSubTItle"> {{ options.buttonCallBackVisible  ?  text.subtitle   : text.subtitlenoWb  }} </p>' +
		          '</div>'+
							//'<div class="row box-card">'+
							//'<div v-for="(day,index) in dataWeek" class="day-card text-center" :class="{ \'is-selected\': isSelected === day.date_number,  \'closed\': isClosed == checIfClosed(index)  }" @click="toggleSelected(day,index)" @mouseover="toggleHours(index, \'in\')" @mouseleave="toggleHours(index, \'out\')">'+
							//		'<h3> {{ day.name }}</h3>'+
							//		'<h4> {{ day.date_number }} </h4>'+
							//		'<p> {{ day.month.name }} </p>'+
							//'</div>'+
							//'</div>'+


						//'<div class="box-hours row offset-top-10" :class="{ \'no-button-callback\': !options.buttonCallBackVisible }">'+
						//'<div v-if="setHours" class="box-set-date offset-top-10">' +
						//		'<div class="col-xs-7 offset-top-10">' +
						//			'<p> {{ text.recontact }} </p>'+
						//			'<p v-if="errorHours" class="message">{{ text.errorTime}}</p>'+
						//		'</div>' +
						//	'<div class="col-xs-5 text-center">' +
						//				'<div class="row">' +
						//						'<button @click="increase(\'hours\')">+</button>'+
						//						'<button @click="increase(\'minutes\')">+</button>'+
						//				'</div>' +
						//				'<div class="row timer">' +
						//						'<span v-if="timer.hours < 10">0</span>'+
						//						'<span>{{ timer.hours }}</span>'+
						//						'<span class="spacer">:</span>'+
						//						'<span v-if="timer.minutes < 10">0</span>'+
						//						'<span>{{ timer.minutes }}</span>'+
						//				'</div>' +
						//				'<div class="row">' +
						//						'<button @click="decrease(\'hours\')">-</button>'+
						//						'<button @click="decrease(\'minutes\')">-</button>'+
						//				'</div>' +
						//		'</div>' +
						//'</div>' +

						//'<div v-if="showHours" class="list-hours offset-top-10" >'+
						//	'<ul class="col-xs-12 row no-gutters">'+
						//		'<i v-if="tempHours[currentiD].listHours.length <= 2" class="material-icons">&#xE8AE;</i>'+
						//		'<li v-for="hours in tempHours[currentiD].listHours" class="no-gutters text-left" :class="{ \'small\': small == checkLenItem(tempHours[currentiD].listHours.length)  }" >'+
						//			'<div class="col-xs-12" v-if="hours.start != hours.end ">'+
						//				'<span>{{ text.from }}:</span><span  class="hours">{{ hours.start }}</span><span>{{ text.to }}:</span><span class="hours">{{ hours.end }}</span>'+
						//			'</div>'+
						//		'</li>'+
						//	'</ul>'+
						//	'<div class="col-xs-12 message" v-if="tempHours[currentiD].message != null ">{{ tempHours[currentiD].message }}</div>'+
						//	'<div class="col-xs-12 message" v-if="tempHours[currentiD].enable == \'false\' ">{{ text.close }}</div>'+

						//'</div>' +

						//'</div>' +


						'<div v-if="options.buttonCallBackVisible" class="bt-choise offset-top-10">' +
							'<button  @click="callFormAsap" class="pull-left btn btn-info"> {{ text.asap }} </button>' +
							//'<button  :disabled="setBtTimeDisable" @click="callFormWithHours"  class="pull-right btn btn-info"> {{ text.set_time }} </button>' +
						'</div>' +



					  '</div>' +
			    '</transition>',
	data: function(){
		return {
			isActive:false,
			isSelected:null,
			small:false,
			isClosed:false,
			isDisabled:true,
			errorHours:false,
			setBtTimeDisable:true,
			dataWeek:[],
			tempHours:[],
			showHours:false,
			setHours:false,
			hasSubTItle:true,
			workingHours: {},
			boxSuccess:false,
			currentiD:null,
			hoursMinor:false,
			minuteMinor:false,
			messageClose:false,
			lastIndexClicked:null,
			delayClock: 5,
			text: {
				title: this.labellang.webcb_no_agent_title,
				subtitle: this.labellang.webcb_no_agent_subtitle,
				subtitlenoWb: this.labellang.webcb_no_agent_subtitle_nowb,
				recontact: this.labellang.webcb_time_prefere,
				set_time: this.labellang.webcb_set_time_button,
				asap: this.labellang.as_soon_as_possible_button,
				from:this.labellang.from_w_h_adv,
				to:this.labellang.to_w_h_adv,
				errorTime:this.labellang.webcb_insert_wrong_time,
				close:this.labellang.closedForThisDate

			},
			week: {
				days: {},
				sort_days: []
			},
			choise: {
				month:{},
				name:'',
				date_number:'',
				time:''
			},
			infoCustomer: {},
			timer: {
				hours: new Date().getHours(),
				minutes: new Date().getMinutes(),
			}
		}
	},

	mounted: function() {
		var that = this;



		this.$parent.$on('onshowWebcallbackHours', function(val) {
      that.contentShow(val);
			if( val == true){
				that.reorganizeListHours();
				that.setDateAndTime();
			}
    });




	},
	methods:{
		contentShow:function(val){
			this.isActive = val;
		},
		reorganizeListHours:function(){
			var d = new Date();
			var today = d.getDay() + 1; 	// Aggiungo il +1 perché mi viene restituito un array che parte da domenica

			this.workingHours = this.options.internal.working_hours;
			var listHours = [];
			var indexTemp = -1;
			// var deletePosition = [];

			for(i=0; i < this.workingHours.length; i++){
				if ( i >0 && this.workingHours[i-1].dayofweek ==  this.workingHours[i].dayofweek)	{ //se il giorno prima è uguale raggrupo le date
					listHours = {
						"start": this.workingHours[i].start,
						"end": this.workingHours[i].end
						}
					this.tempHours[indexTemp].listHours.push(listHours);

				}else if ( i==0 || this.workingHours[i-1].dayofweek != this.workingHours[i].dayofweek ){
					indexTemp++;
					this.tempHours[indexTemp] = this.workingHours[i];
					listHours = [
										{ "start": this.workingHours[i].start,
												"end": this.workingHours[i].end
					}];
					this.tempHours[indexTemp].listHours = listHours;

				}

			}


		},
		dalayTimeClock:function(){
				// old
				// var newMinuteTime = this.timer.minutes + this.delayClock;
				// if( newMinuteTime >= 59){
				// 	var scarto = newMinuteTime - 59;
				// 	this.timer.minutes = scarto;
        //
				// 	this.timer.hours += 1;
				// 	if( this.timer.hours >= 23){
				// 			this.timer.hours = 00;
				// 	}
				// }else{
				// 	this.timer.minutes += this.delayClock;
				// }

		},
		setDateAndTime: function() {
			this.dataWeek = [];
			var d = new Date();
			var today = d.getDay() + 1;	// Aggiungo il +1 perché mi viene restituito un array che parte da domenica
			var weekFlag = 1, weekLength = 8;

			var dayObj = {};
			dayObj.name = this.labellang.day_abbr[today];
			dayObj.id = today;
			dayObj.date_number = d.getDate();
			dayObj.month = {};
			dayObj.month.name = this.labellang.month_abbr[d.getMonth()];
			dayObj.month.number = d.getMonth();
			dayObj.year = d.getFullYear();


			this.dataWeek.push(dayObj);
			/*
			*	Immaginare array ordinato dalla domenica al sabato
			*	Prendo il giorno corrente e ciclo sui successivi
			*	considerando il modulo nel caso in cui arrivo al limite dell'array
			*/
			for(var i = today + 1 ; weekFlag < weekLength; i++) {
				// Se ho raggiunto il limite dell'array, riparto dalla prima posizione
				if(i >= weekLength) {
					i %= weekLength;
					if(i === 0){
						i = i + 1;
					}
				}
				dayObj = {};
				dayObj.name = this.labellang.day_abbr[i];
				dayObj.id = i;
				d.setDate(d.getDate() + 1);
				dayObj.date_number = d.getDate();	// Setto la prossima data
				dayObj.month = {};
				dayObj.month.name = this.labellang.month_abbr[d.getMonth()];
				dayObj.month.number = d.getMonth();
				dayObj.year = d.getFullYear();
				this.dataWeek.push(dayObj);
				weekFlag++;
			}
		},
		updateTime:function(){

			this.choise.time = this.timer.hours + ':' + this.timer.minutes;
			this.choise.hours = this.timer.hours;
			this.choise.minutes = this.timer.minutes;

		},
		isToday:function(){
			var currentDate = new Date() ;
			var TodayDay =  currentDate.getDay() + 1 ;
			var curretDaySelecet = this.choise.dayofweek;

			if( curretDaySelecet == TodayDay ){
				return true;
			}else{
				return false;
			}

		},
		reverseDate:function(str){
			return str.split('-').reverse().join('-');
		},
		checkRangeDateAvailable:function(){
				var lastIndex = this.lastIndexClicked;
				var hTimer = String(this.timer.hours);
				var mTimer = String(this.timer.minutes);
				var currentDate = (this.reverseDate(this.tempHours[lastIndex].formattedDate)).replace("-","/");
				var start = currentDate;
				var end = currentDate;
				var hstart = this.tempHours[lastIndex].listHours[0].start;
				var hend = this.tempHours[lastIndex].listHours[0].end;
				var hoursAvailable = "";
				var mapHours = [];
				// console.log("start= "+start)
				// console.log("hTimer= "+hTimer)
				// console.log("mTimer= "+mTimer)
				for(i=0; i< this.tempHours[lastIndex].listHours.length; i++ ){
					var hstart = this.tempHours[lastIndex].listHours[i].start
					var hend = this.tempHours[lastIndex].listHours[i].end
					var millisecondFixForIe = ":00";
					// console.log("hstart= "+hstart)
					// console.log("hend= "+hend)
					var startDate = new Date(start+' '+hstart+millisecondFixForIe)
					var endDate = new Date(end+' '+hend+millisecondFixForIe)
					var fullTimer = ( hTimer+':'+ mTimer)
					// console.log("startDate= "+startDate)
					// console.log("endDate= "+endDate)
					// console.log("fullTimer= "+fullTimer)
					var toset = new Date( currentDate+' '+fullTimer+millisecondFixForIe)
					// console.log("toset= "+toset)
					if(startDate <= toset && toset <= endDate){
						hoursAvailable = "open";
						mapHours.push(hoursAvailable)

					}else{
						hoursAvailable = "close";
						mapHours.push(hoursAvailable)

					};
					// console.log("mapHours")
					// console.log(mapHours)
				}
				// console.log("mapHours after for")
				// console.log(mapHours)
				var containsHoursAvailable = mapHours.indexOf("open"); 	// if se almeno una è comepresa abilito;
				// console.log("containsHoursAvailable")
				// console.log(containsHoursAvailable)

				if( containsHoursAvailable != -1 ){
					this.errorHours = false;
					this.setBtTimeDisable = false;
				}else{
					this.errorHours = true;
					this.setBtTimeDisable = true;
				}


		},
		isExpeptionDay:function(index){
			return this.tempHours[index].isExceptionDate;
		},
		checIfClosed:function(index){
			if (this.tempHours && this.tempHours[index] && this.tempHours[index].isExceptionDate && this.tempHours[index].listHours[0].start == this.tempHours[index].listHours[0].end || this.tempHours && this.tempHours[index] && this.tempHours[index].enable == "false"){
				return false;
			}
			return true;
		},
		checkLenItem:function(len){
			if(len > 2){ // set for more 1 item the small font
				return false;
			}
			return true;
		},
		toggleSelected: function (day,index) {

			if(!this.options.buttonCallBackVisible){
				return;
			}

			var currentDate = new Date() ;
			var currentHours = currentDate.getHours();
			var currentMinutes = currentDate.getMinutes();
			var haveException = this.tempHours[index].isExceptionDate;
			var enable = this.tempHours[index].enable;
			var isSemiclosed = this.tempHours[index].isExceptionDate && this.tempHours[index].listHours[0].start != this.tempHours[index].listHours[0].end;

			if( enable == "false"){
				haveException = true;
			}

			this.lastIndexClicked = index;


			if(!haveException || isSemiclosed ){


				if (this.isSelected == day.date_number) { //Self delete all
					this.isSelected = false;
					this.setHours = false;
				} else {
					this.isSelected = day.date_number;
					this.choise.month.name = day.month.name;
					this.choise.month.number = day.month.number;
					this.choise.name = day.name;
					this.choise.year = day.year;
					this.choise.date_number = day.date_number;
					this.choise.time = this.timer.hours + ':' + this.timer.minutes;
					this.choise.hours = this.timer.hours;
					this.choise.minutes = this.timer.minutes;
					this.choise.dayofweek = day.id;
			//		this.setBtTimeDisable = false;
					this.setHours = true;

				}

				this.showHours = false;


			if (this.isToday() && this.timer.hours <= currentHours) { // if change day and the date for today is minor return curret hours o minute
			  this.timer.hours = currentHours;
				this.updateTime();
			}
			if (this.isToday() && this.timer.minutes <= currentMinutes) {
		 			this.timer.minutes = currentMinutes;
					this.updateTime();
			}
			}

			this.checkRangeDateAvailable();


		},
		toggleHours:function(id,typeToggle){


			if(!this.setHours){
				if(typeToggle == 'in'){
					$(".list-hours").find("ul").fadeIn(30);
				}else{
					$(".list-hours").find("ul").hide();
				}
				this.showHours =  true;
				this.currentiD = id;
			}

		},
		increase: function (type) {
			var currentDate = new Date() ;
			var curretDaySelecet = this.choise.dayofweek;
			var currentHours = currentDate.getHours();
			var currentMinutes = currentDate.getMinutes();



			if(type == "hours") {
				this.timer.hours += 1;
				if(this.timer.hours > 23) {
					if(!this.isToday()){
						this.timer.hours = 0;
					}else{
						return this.timer.hours = 23;
					}
				}
			} else {
				this.timer.minutes += 1;

				if(this.isToday() &&  this.timer.hours >= 23 && this.timer.minutes > 59  ){
						return this.timer.minutes = 59;
				}else{
					if(this.timer.minutes > 59)  {
						this.timer.minutes = 0;
						if(this.timer.hours >= 23) {
							this.timer.hours = 0;
						}
					}
				}
			}
			this.checkRangeDateAvailable();
		},
		decrease: function (type) {

			var currentDate = new Date() ;
			var curretDaySelecet = this.choise.dayofweek;
			var currentHours = currentDate.getHours();
			var currentMinutes = currentDate.getMinutes();


			if(!this.isToday()){ // if no today decrease Hours
				if(type == "hours"){
					if(this.timer.hours > 0) {
						this.timer.hours -= 1;

					}
				} else {
					if(this.timer.minutes > 0) {
						this.timer.minutes -= 1;
					}
				}
			}else{
				if(type == "hours"){
					// check hours minor
					if( this.timer.hours <=  currentHours  ){
						//console.log("Hours minore");
						this.hoursMinor = true;
					}else{
						this.hoursMinor = false;
						if(this.timer.hours > 0) {
							this.timer.hours -= 1;
						}
					}
					if(this.timer.hours == currentHours){
						if(currentMinutes >= this.timer.minutes  ){
							this.timer.minutes = currentMinutes;
						}
					}
				} else {
					// check minute minor
					if( this.timer.minutes <=  currentMinutes &&  this.timer.hours == currentHours   ){
						//console.log("miniute minore");
						this.minuteMinor = true;
					}
					else {
						this.minuteMinor = false;
						if(this.timer.minutes > 0) {
							this.timer.minutes -= 1;
						}
					}
				}

			}
			this.checkRangeDateAvailable();

		},
		callFormWithHours:function(){
			this.updateTime();
			bus.$emit("onWebCallBackForm", true);
			bus.$emit("onWebCallBackFormDataChoise", this.choise);

		},
		callFormAsap:function(){
			this.isSelected = false;
			this.setHours = false;
			bus.$emit("onWebCallBackForm", true);
			bus.$emit("onWebCallBackFormNoData");
		}
	}
})
